const WellnessStreaks = ({
  curDayStreak,
  curWeekStreak,
  maxDayStreak,
  maxWeekStreak,
  goalWeekRef,
  goalDayRef,
}) => {
  const possibleDayStreaks = [
    3, 5, 7, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 125, 150, 175, 200, 250,
    300, 365, 500, 730, 1095, 1460, 1825,
  ];

  const possibleWeekStreaks = [
    2, 3, 5, 10, 20, 30, 40, 52, 60, 70, 80, 90, 104, 156, 208, 260, 312, 364,
    416, 468, 520,
  ];

  const safeMaxDayStreak = Math.max(0, Number(maxDayStreak) || 0);
  const currentGoal =
    possibleDayStreaks.find((goal) => safeMaxDayStreak < goal) ||
    possibleDayStreaks[possibleDayStreaks.length - 1];
  const percentage = Math.min(
    100,
    Math.max(
      0,
      Number(((safeMaxDayStreak / currentGoal) * 100).toFixed(1)) || 0
    )
  );

  const safeMaxWeekStreak = Math.max(0, Number(maxWeekStreak) || 0);
  const currentWeekGoal =
    possibleWeekStreaks.find((goal) => safeMaxWeekStreak < goal) ||
    possibleWeekStreaks[possibleWeekStreaks.length - 1];
  const weekPercentage = Math.min(
    100,
    Math.max(
      0,
      Number(((safeMaxWeekStreak / currentWeekGoal) * 100).toFixed(1)) || 0
    )
  );

  const getNearestStreakValue = () => {
    const currMax = maxDayStreak;
    const streak_arr = possibleDayStreaks;

    if (currMax < streak_arr[0]) {
      return 0;
    }

    for (let i = 1; i < streak_arr.length; i++) {
      const streakVal = streak_arr[i];
      if (currMax === streakVal) {
        return streakVal;
      } else if (currMax < streakVal) {
        return streak_arr[i - 1];
      }
    }
    return streak_arr[streak_arr.length - 1];
  };

  const nearestStreakVal = getNearestStreakValue();

  const DayStreaks = ({ curDayStreak, maxDayStreak, goalDayRef }) => {
    return (
      <div className="flex overflow-x-auto p-2 whitespace-nowrap">
        {possibleDayStreaks.map((streakNum, index) => {
          const isAchieved = maxDayStreak && streakNum <= maxDayStreak;
          const imgSrc = isAchieved
            ? `../images/streaks/dayStreaks/Color/${streakNum}DaysColor.png`
            : `../images/streaks/dayStreaks/Grey/${streakNum}DaysGrey.png`;

          const isYearFormat = [365, 730, 1095, 1460, 1825].includes(streakNum);
          const isOneYear = [365].includes(streakNum);
          const textColor = isAchieved ? "white" : "#5C5C5C";

          const isNextGoal = streakNum === currentGoal;

          return (
            <div
              key={index}
              ref={isNextGoal ? goalDayRef : null}
              className="streakDisplayItem"
            >
              <img
                src={imgSrc}
                alt={`Streak ${streakNum}`}
                className="streakItemImage"
              />
              {isYearFormat ? (
                <>
                  {isOneYear ? (
                    <div className="yearText" style={{ color: textColor }}>
                      YEAR
                    </div>
                  ) : (
                    <div className="yearText" style={{ color: textColor }}>
                      YEARS
                    </div>
                  )}
                  <div
                    className="daysText yearDaysText"
                    style={{ color: textColor }}
                  >
                    DAYS
                  </div>
                </>
              ) : (
                <div className="daysText" style={{ color: textColor }}>
                  DAYS
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const WeekStreaks = ({ curWeekStreak, maxWeekStreak, goalWeekRef }) => {
    return (
      <div className="flex overflow-x-auto p-2 whitespace-nowrap">
        {possibleWeekStreaks.map((streakNum, index) => {
          const isAchieved = maxWeekStreak && streakNum <= maxWeekStreak;
          const imgSrc = isAchieved
            ? `../images/streaks/weekStreaks/Color/${streakNum}WeeksColor.png`
            : `../images/streaks/weekStreaks/Grey/${streakNum}WeeksGrey.png`;

          const isYearFormat = [
            52, 104, 156, 208, 260, 312, 364, 416, 468, 520,
          ].includes(streakNum);
          const isTenYear = streakNum === 520;
          const isOneYear = streakNum === 52;
          const textColor = isAchieved ? "white" : "#5C5C5C";

          const isNextGoal = streakNum === currentWeekGoal;

          return (
            <div
              key={index}
              ref={isNextGoal ? goalWeekRef : null}
              className="streakDisplayItem"
            >
              <img
                src={imgSrc}
                alt={`Streak ${streakNum}`}
                className="streakItemImage"
              />
              {isYearFormat ? (
                <>
                  {isOneYear ? (
                    <div
                      className="yearTextWeekStreak"
                      style={{ color: textColor }}
                    >
                      YEAR
                    </div>
                  ) : isTenYear ? (
                    <div
                      className="tenYearTextWeekStreak"
                      style={{ color: textColor }}
                    >
                      YEARS
                    </div>
                  ) : (
                    <div
                      className="yearTextWeekStreak"
                      style={{ color: textColor }}
                    >
                      YEARS
                    </div>
                  )}
                  <div
                    className="weeksText yearWeeksText"
                    style={{ color: textColor }}
                  >
                    WEEKS
                  </div>
                </>
              ) : (
                <div className="weeksText" style={{ color: textColor }}>
                  WEEKS
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full">
      <div
        className={`rounded-xl p-3 mb-2 sm:mb-4 w-full sm:w-1/2 ${
          maxDayStreak === currentGoal
            ? "bg-[#EBF5FF]"
            : "bg-white border-1 border-dashed border-[#3578E8]"
        }`}
      >
        <div className="flex flex-row gap-3">
          <div className="w-8 h-8 rounded-full bg-[#C7E1FC] flex items-center justify-center">
            <img
              src={`../images/streaks/genericStreaks/BlankStreakBluecolor.png`}
              className="w-4 h-auto"
            />
          </div>
          <div>
            <div className="text-[16px] font-bold">Day Streak</div>
            <div className="text-[12px] mb-2">
              Practice multiple days in a row
            </div>
          </div>
        </div>
        <DayStreaks
          curDayStreak={curDayStreak}
          maxDayStreak={maxDayStreak}
          goalDayRef={goalDayRef}
        ></DayStreaks>

        <div className="w-full bg-gray-200 h-1.5 rounded mb-2 mt-2">
          <div
            className="bg-[#3578E8] h-full rounded transition-all duration-300"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <p
          className={`${
            maxDayStreak === currentGoal ? "text-[#3578E8]" : "text-black"
          } text-[12px]`}
        >
          {maxDayStreak > 0 ? (
            <>
              {maxDayStreak} of {currentGoal} days completed!
            </>
          ) : (
            <span className="text-gray-500">Not started</span>
          )}
        </p>
      </div>

      <div
        className={`rounded-xl p-3 mb-2 sm:mb-4 w-full sm:w-1/2 ${
          maxWeekStreak === currentWeekGoal
            ? "bg-[#EBF5FF]"
            : "bg-white border-1 border-dashed border-[#3578E8]"
        }`}
      >
        <div className="flex flex-row gap-3">
          <div className="w-8 h-8 rounded-full bg-[#C7E1FC] flex items-center justify-center">
            <img
              src={`../images/streaks/genericStreaks/BlankStreakBluecolor.png`}
              className="w-4 h-auto"
            />
          </div>
          <div>
            <div className="text-[16px] font-bold">Week Streak</div>
            <div className="text-[12px] mb-2">
              Practice multiple weeks in a row
            </div>
          </div>
        </div>
        <WeekStreaks
          curWeekStreak={curWeekStreak}
          maxWeekStreak={maxWeekStreak}
          goalWeekRef={goalWeekRef}
        ></WeekStreaks>

        <div className="w-full bg-gray-200 h-1.5 rounded mb-2 mt-2">
          <div
            className="bg-[#3578E8] h-full rounded transition-all duration-300"
            style={{ width: `${weekPercentage}%` }}
          />
        </div>

        <p
          className={`${
            maxWeekStreak === currentWeekGoal ? "text-[#3578E8]" : "text-black"
          } text-[12px]`}
        >
          {maxWeekStreak > 0 ? (
            <>
              {maxWeekStreak} of {currentWeekGoal} weeks completed!
            </>
          ) : (
            <span className="text-gray-500">Not started</span>
          )}
        </p>
      </div>
    </div>
  );
};

export default WellnessStreaks;
